import type { ControlRegisterResponse } from '@risksmart-app/trpc/src/types';
import type { GetControlsQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetControlsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

import { mapTrpcControlToGraphQL } from './useGetControlsRegister';

type UseLazyGetControlsByParentIdRegisterArgs = {
  parentId: string;
};

export const useLazyGetControlsByParentIdRegister = createLazyQueryHook<
  UseLazyGetControlsByParentIdRegisterArgs,
  ControlRegisterResponse,
  GetControlsQuery
>({
  trpcQuery: (client, { parentId }) =>
    client.frontend.control.register.query({ parentId }),
  mapTrpcDataToGraphQL: (data) => ({
    control: data.map((control) => mapTrpcControlToGraphQL(control)),
  }),
  graphqlDocument: GetControlsDocument,
  graphqlVariables: ({ parentId }) => ({
    where: { parents: { ParentId: { _eq: parentId } } },
  }),
});
